import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "chat-header-name" }
const _hoisted_2 = { class: "chat-header-container" }
const _hoisted_3 = {
  key: 0,
  class: "language-selector"
}
const _hoisted_4 = {
  key: 0,
  class: "dropdown-popup"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "language" }
const _hoisted_7 = { class: "language-code" }
const _hoisted_8 = { class: "language-name" }

import vue from '../../../adapter-vue';
import {
  TUIStore,
  StoreName,
  TUITranslateService,
  IConversationModel,
} from '../../../@aidesk/uikit-engine';
import Icon from '../../common/Icon.vue';
import backSVG from '../../../assets/back.svg';
import arrowDown from '../../../assets/language_arrow_down.svg';
import customerAvatarMobile from '../../../assets/customer_avatar_mobile.png';
import languageSelectedIcon from '../../../assets/language_check.svg';
import { isH5 } from '../../../utils/env';
import state from '../../../utils/state';
import { SUPPORTED_LANGUAGES } from '../../../constant';
import { IHeaderConfig } from '../../../interface';
interface IProps {
  canCloseChat?: boolean;
  currentLang?: string;
  enableMultilingual: number;
  langList?: Array<string>;
  headerConfig?: IHeaderConfig;
}
interface ILanguage {
  name: string;
  code: string;
  codeForShow: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index-web',
  props: {
    canCloseChat: { type: Boolean, default: true },
    currentLang: { default: '' },
    enableMultilingual: { default: 0 },
    langList: { default: () => [] },
    headerConfig: {}
  },
  emits: ['closeChat','changeLanguage'],
  setup(__props: any, { emit: __emit }) {

const { ref, onMounted, onUnmounted, computed } = vue;

const emits = __emit;
const currentConversation = ref<IConversationModel>();
const currentConversationName = ref('');
const isTyping = ref(false);
const showDropdown = ref(false);
const languageOptionList = ref<Array<ILanguage>>([]);
const currentLanguageOption = ref<ILanguage>({name:'',code:'',codeForShow:''});
 
const props = __props;

const showHeaderIcon = computed(() => {
  if (isH5) {
    if (props.headerConfig && props.headerConfig.showLogo === false) {
      return false;
    }
    return true;
  }
  return false;
});

const headerIcon = computed(() => {
  return (props.headerConfig && props.headerConfig.logo) || customerAvatarMobile;
});

const headerIconWidth = computed(() => {
  return (props.headerConfig && props.headerConfig.logoWidth) ?? '32px';
});

const headerIconHeight = computed(() => {
  if (props.headerConfig) {
    return props.headerConfig.logoHeight || '32px';
  }
  return '23px';
});

if (props.enableMultilingual === 1) {
  languageOptionList.value = props.langList
  .map(key => ({
    code: key,
    codeForShow: SUPPORTED_LANGUAGES[key].codeForShow,
    name: SUPPORTED_LANGUAGES[key].name,
  }));
  currentLanguageOption.value = languageOptionList.value.find(option => option.code === props.currentLang);
}

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdated,
  });

  TUIStore.watch(StoreName.CUSTOM, {
    isTyping: onTypingStatusUpdated,
  });
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdated,
  });

  TUIStore.unwatch(StoreName.CUSTOM, {
    isTyping: onTypingStatusUpdated,
  });
});

const closeChat = (conversationID: string | undefined) => {
  emits('closeChat', conversationID);
};

function setCurrentConversationName() {
  if (!currentConversation.value) {
    return;
  }
  if (props.headerConfig && props.headerConfig.title) {
    currentConversationName.value = props.headerConfig.title;
  } else {
    currentConversationName.value = currentConversation.value.getShowName() || '';
  }
}

function onCurrentConversationUpdated(conversation: IConversationModel) {
  currentConversation.value = conversation;
  setCurrentConversationName();
}

function onTypingStatusUpdated(data: {conversationID: string, value: boolean}) {
  if (data && data.conversationID === currentConversation.value.conversationID) {
    isTyping.value = data.value;
    if (isTyping.value && state.get('showTyping') === 1) {
      currentConversationName.value = TUITranslateService.t('TUIChat.对方正在输入');
    } else {
      setCurrentConversationName();
    }
  }
}

function toggleDropdown() {
  showDropdown.value = !showDropdown.value
}

function selectLanguage(languageOption) {
  showDropdown.value = false;
  currentLanguageOption.value = languageOption;
  emits('changeLanguage', languageOption.code);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['chat-header', _unref(isH5) && 'chat-header-h5'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(isH5) && props.canCloseChat)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['chat-header-back', _unref(isH5) && 'chat-header-h5-back']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (closeChat(_unref(currentConversation).conversationID)))
          }, [
            _createVNode(Icon, { file: _unref(backSVG) }, null, 8, ["file"])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_unref(showHeaderIcon))
          ? (_openBlock(), _createBlock(Icon, {
              key: 0,
              width: _unref(headerIconWidth),
              height: _unref(headerIconHeight),
              file: _unref(headerIcon)
            }, null, 8, ["width", "height", "file"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(['chat-header-content', _unref(isH5) && 'chat-header-h5-content'])
        }, _toDisplayString(_unref(currentConversationName)), 3)
      ])
    ]),
    (props.enableMultilingual === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "selected-language-option",
            onClick: toggleDropdown
          }, [
            _createTextVNode(_toDisplayString(_unref(currentLanguageOption).name) + " ", 1),
            _createElementVNode("span", {
              class: _normalizeClass(["arrow", { 'arrow-up': _unref(showDropdown) }])
            }, [
              _createVNode(Icon, {
                file: _unref(arrowDown),
                width: "12px",
                height: "12px"
              }, null, 8, ["file"])
            ], 2)
          ]),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_unref(showDropdown))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languageOptionList), (option) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: option.code,
                        class: _normalizeClass(['dropdown-item',_unref(currentLanguageOption).code === option.code ? 'dropdown-item-selected' : '']),
                        onClick: ($event: any) => (selectLanguage(option))
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, _toDisplayString(option.codeForShow), 1),
                          _createElementVNode("div", _hoisted_8, _toDisplayString(option.name), 1)
                        ]),
                        (_unref(currentLanguageOption).code === option.code)
                          ? (_openBlock(), _createBlock(Icon, {
                              key: 0,
                              file: _unref(languageSelectedIcon),
                              width: "20px",
                              height: "20px"
                            }, null, 8, ["file"]))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_5))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})